export const Sparkle = ({ className = "", style }) => (
  <svg viewBox="0 0 24 24" fill="currentColor" className={className} style={style} aria-hidden="true">
    <path d="M12 2c.9 5.2 2.9 7.1 8 8-5.1.9-7.1 2.8-8 8-.9-5.2-2.9-7.1-8-8 5.1-.9 7.1-2.8 8-8z" />
  </svg>
);

export const FloatingSparkle = ({ className = "", size = 20, delay = 0, duration = 5 }) => (
  <span
    className={`pointer-events-none absolute animate-twinkle ${className}`}
    style={{ animationDelay: `${delay}s`, animationDuration: `${duration}s` }}
  >
    <Sparkle className={className} style={{ width: size, height: size }} />
  </span>
);
